<template>
  <div class="modify-policy-container">
    <el-card title="保单批改">
      <el-form ref="modifyForm" :model="modifyForm" label-width="120px">

        <!-- 新增：保单号和渠道号显示 -->
        <el-form-item label="保单号">
          <el-input v-model="policyNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="渠道号">
          <el-input v-model="productName" disabled></el-input>
        </el-form-item>
        <!-- 批改生效时间 -->
        <el-form-item label="批改生效时间" prop="effectiveDate">
          <el-date-picker
            v-model="modifyForm.effectiveDate"
            type="date"
            placeholder="选择批改生效日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            required
          ></el-date-picker>
        </el-form-item>

        <!-- Excel文件导入 -->
        <el-form-item label="导入Excel文件">

          <!-- 调整按钮位置，使其显示在标签下一行并保持左对齐 -->
          <div style="clear: both; text-align: left; margin-bottom: 10px;">
            <el-button
              type="default"
              @click="downloadConfirmationTemplate('批改模板.xlsx')"
              icon="el-icon-download"
              size="medium"
            >
              下载模板
            </el-button>
          </div>
          <el-upload
            class="upload-excel"
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            accept=".xlsx,.xls"
            ref="upload"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传xlsx/xls文件，且不超过5MB
            </div>
          </el-upload>
        </el-form-item>

        <!-- 操作按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitModify">提交批改</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {service} from '../../utils/axios'
import {getToken} from '../../utils/auth'

export default {
  name: 'ModifyPolicy',
  data () {
    return {
      modifyForm: {
        effectiveDate: '', // 批改生效时间
        excelFile: null // 导入的Excel文件
      }, // 新增：存储路由参数
      policyNo: '',
      productName: '',
      productId: '',
      pickerOptions: {
        disabledDate: (date) => {
          // 获取今天的日期并设置时间为23:59:59:999
          const today = new Date()
          today.setHours(23, 59, 59, 999)
          // 如果选择的日期小于等于今天，则禁用
          return date <= today
        }
      }
    }
  },
  created () {
    console.log(this.$route.query)
    // 从路由参数中获取数据
    this.policyNo = this.$route.query.policyNo
    this.productId = this.$route.query.productId
    this.productName = this.$route.query.productName

    // 验证参数是否存在
    if (!this.policyNo || !this.productId) {
      this.$message.error('缺少保单信息，无法进行批改操作')
      this.$router.go(-1)
    }
  },
  methods: {
    downloadConfirmationTemplate (fileName) {
      try {
        // 创建一个临时的a标签用于下载
        const link = document.createElement('a')
        // 设置下载文件的路径
        link.href = '/static/' + fileName
        link.download = fileName // 设置下载文件名
        // 触发点击事件开始下载
        document.body.appendChild(link)
        link.click()
        // 下载完成后移除a标签
        setTimeout(() => {
          document.body.removeChild(link)
        }, 100)
      } catch (error) {
        console.error('下载失败:', error)
        this.$message.error('文件下载失败，请检查文件是否存在')
      }
    },

    // 处理文件选择
    handleFileChange (file, fileList) {
      this.modifyForm.excelFile = file.raw
    },

    // 提交批改
    submitModify () {
      this.$refs.modifyForm.validate(valid => {
        if (valid) {
          if (!this.modifyForm.excelFile) {
            this.$message.error('请选择Excel文件')
            return
          }

          this.$confirm('确定要批改吗？', '确认批改', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // 实际项目中这里会发送请求到后端
            setTimeout(async () => {
              try {
                // 创建FormData对象处理multipart/form-data类型数据
                const formData = new FormData()

                this.isSubmitting = true
                // 添加请求参数（普通字段）
                formData.append('productId', this.productId)
                formData.append('policyNo', this.policyNo)
                formData.append('startTime', this.modifyForm.effectiveDate)
                // 添加文件（如果是文件对象需要这样处理）
                if (this.modifyForm.excelFile) {
                  formData.append('file', this.modifyForm.excelFile)
                }

                // 发送POST请求
                const res = await service.post(
                  '/andeEIC/eicAccidentInsurance/correctEIC',
                  formData, // 请求体数据（FormData格式）
                  {
                    headers: {
                      'x-access-token': getToken()
                    },
                    timeout: 100000 // 超时设置
                  }
                )
                // 处理响应（注意axios响应数据在res.data中）
                if (res.success) {
                  // 成功逻辑
                  this.$message.success('批改成功')
                  // this.resetForm()

                  this.$router.push({
                    path: '/SidebarMenu/policyCorrectionList',
                    query: { saleId: this.$route.query.saleId }
                  }).then(() => {
                    console.log('路由跳转成功')
                  }).catch(err => {
                    console.error('路由跳转失败:', err)
                  })
                } else {
                  // 失败逻辑
                  this.$message.error(`批改失败: ${res.message || '未知错误'}`)
                }
              } catch (error) {
                if (error.response && error.response.status === 401) {
                  this.$message.error('登录过期，请重新登录')
                  this.$router.push({path: '/login'})
                }
                // 捕获请求异常（网络错误、超时等）
                console.error('请求发生错误:', error.message)
                this.$message.error(error.message)
              } finally {
                this.isSubmitting = false
              }
            }, 500)
          })

          // // 这里添加文件上传和表单提交逻辑
          // const formData = new FormData()
          // formData.append('effectiveDate', this.modifyForm.effectiveDate)
          // formData.append('file', this.modifyForm.excelFile)
          //
          // // 模拟API请求
          // this.$message.success('批改提交成功')
          // this.cancel()
        }
      })
    },

    // 取消操作
    cancel () {
      this.$refs.modifyForm.resetFields()
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.modify-policy-container {
  padding: 20px;
}

.upload-excel {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/modifyPolicy.vue